export default "__VITE_ASSET__ClJzyTkw__"